<div class="modal-header"><h2 class="modal-title">QuickBooks Export</h2></div>
<div class="modal-body">
    <div class="grid-fill" *ngIf="items && mode=='invoices'">
        <dx-data-grid #dataGrid [dataSource]="items" height="800" keyExpr="id" [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
            <dxi-column dataField="invoiceNumber" caption="Invoice#" width="100"></dxi-column>
            <dxi-column dataField="createDate" caption="Invoice Date" width="100"></dxi-column>
            <dxi-column dataField="dealer.companyName" caption="Dealer" width="350"></dxi-column>
            <dxi-column dataField="freight" caption="Freight" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="totalCalc" caption="Total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="markedBy" caption="Marked Ready By" width="200"></dxi-column>
            <dxi-column dataField="readyToExport" width="200"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <div *dxTemplate="let data of 'toolbarButtons'">
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="items" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }} </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
    <div class="grid-fill" *ngIf="items && mode=='dealers'">
        <dx-data-grid #dataGrid [dataSource]="items" height="800" keyExpr="id" [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
            <dxi-column dataField="id" caption="Id" width="100"></dxi-column>
            <dxi-column dataField="companyName" caption="Dealer" width="350"></dxi-column>
            <dxi-column dataField="quickBooksOnlineId" caption="QuickBooks Online Id" width="150"></dxi-column>
            <dxi-column dataField="quickBooksOnlineLastExport" caption="Last Export" width="200"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <div *dxTemplate="let data of 'toolbarButtons'">
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="items" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }} </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
    <div class="grid-fill" *ngIf="items && mode=='vendors'">
        <dx-data-grid #dataGrid [dataSource]="items" height="800" keyExpr="id" [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
            <dxi-column dataField="id" caption="Id" width="100"></dxi-column>
            <dxi-column dataField="companyName" caption="Vendor" width="350"></dxi-column>
            <dxi-column dataField="quickBooksOnlineId" caption="QuickBooks Online Id" width="150"></dxi-column>
            <dxi-column dataField="quickBooksOnlineLastExport" caption="Last Export" width="200"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <div *dxTemplate="let data of 'toolbarButtons'">
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="items" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }} </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
    <div class="grid-fill" *ngIf="items && mode=='purchaseOrders'">
        <dx-data-grid #dataGrid [dataSource]="items" height="800" keyExpr="id" [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
            <dxi-column dataField="id" caption="Id" width="100"></dxi-column>
            <dxi-column dataField="pONumber" caption="PO#" width="100"></dxi-column>
            <dxi-column dataField="pODate" caption="Date" width="100"></dxi-column>
            <dxi-column dataField="vendor.companyName" caption="Vendor" width="350"></dxi-column>
            <dxi-column dataField="quickBooksOnlineId" caption="QuickBooks Online Id" width="150"></dxi-column>
            <dxi-column dataField="quickBooksOnlineLastExport" caption="Last Export" width="200"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <div *dxTemplate="let data of 'toolbarButtons'">
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="items" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }} </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
    <div class="mt-1 m-1" *ngIf="items && mode=='invoiceResults'">
        <dx-data-grid #dataGrid [dataSource]="items" height="500" keyExpr="Id" [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)">
            <dxi-column dataField="invoiceNumber" caption="#" width="100"></dxi-column>
            <dxi-column dataField="dealer" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="Message" width="500"></dxi-column>
            <dxi-column dataField="TimeStamp" caption="Time Stamp" width="100"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <div *dxTemplate="let data of 'toolbarButtons'">
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="items" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }} </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>

<div class="modal-footer">
    <button *ngIf="!showingResults" type="button" class="btn btn-success" (click)="save()">Export</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()">{{ !showingResults ? 'Cancel' : 'Close'}}</button>
</div>
